/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';
import type { EmployeePayDetails } from './EmployeePayDetails';
import {
    EmployeePayDetailsFromJSON,
    EmployeePayDetailsFromJSONTyped,
    EmployeePayDetailsToJSON,
    EmployeePayDetailsToJSONTyped,
} from './EmployeePayDetails';

/**
 * Employee Pay Information, With Batch Summary
 * @export
 * @interface EmployeePayDetailsWithBatchSummary
 */
export interface EmployeePayDetailsWithBatchSummary {
    /**
     * 
     * @type {EmployeePayDetails}
     * @memberof EmployeePayDetailsWithBatchSummary
     */
    model: EmployeePayDetails;
    /**
     * 
     * @type {BatchSummary}
     * @memberof EmployeePayDetailsWithBatchSummary
     */
    batchSummary?: BatchSummary;
}

/**
 * Check if a given object implements the EmployeePayDetailsWithBatchSummary interface.
 */
export function instanceOfEmployeePayDetailsWithBatchSummary(value: object): value is EmployeePayDetailsWithBatchSummary {
    if (!('model' in value) || value['model'] === undefined) return false;
    return true;
}

export function EmployeePayDetailsWithBatchSummaryFromJSON(json: any): EmployeePayDetailsWithBatchSummary {
    return EmployeePayDetailsWithBatchSummaryFromJSONTyped(json, false);
}

export function EmployeePayDetailsWithBatchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeePayDetailsWithBatchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'model': EmployeePayDetailsFromJSON(json['model']),
        'batchSummary': json['batchSummary'] == null ? undefined : BatchSummaryFromJSON(json['batchSummary']),
    };
}

  export function EmployeePayDetailsWithBatchSummaryToJSON(json: any): EmployeePayDetailsWithBatchSummary {
      return EmployeePayDetailsWithBatchSummaryToJSONTyped(json, false);
  }

  export function EmployeePayDetailsWithBatchSummaryToJSONTyped(value?: EmployeePayDetailsWithBatchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'model': EmployeePayDetailsToJSON(value['model']),
        'batchSummary': BatchSummaryToJSON(value['batchSummary']),
    };
}

